<script>
// From https://stackoverflow.com/a/40388120
//
// Use in views like:
// <vue-title title="Static Title"></vue-title>
// <vue-title :title="dynamic.something + ' - Static'"></vue-title>

export default {

  name: "Vue-title",
  props: ["title"],

  created() {
    document.title = this.title;
  },

  watch: {
    title() {
      // only used when the title changes after page load
      document.title = this.title;
    }
  },
  render() {}

};
</script>



// WEBPACK FOOTER //
// src/components/Vue-title.vue